import CTLUnReadCell from "application/components/CTLUnReadCell";
import DefaultCell from "application/components/DefaultCell";
import RowAction from "application/components/RowAction";
import { actionCodeMenus } from "globals/configuration/pbxServiceMenu";
import formControl from "globals/form-control";

const Attributes = {
  formSize: "md",
  columns: 1,
  enableAddButton: true,
  enableAdvanceSearch: true,
  modes: actionCodeMenus.map((item) => {
        return {
          id: item.key,
          name: item.name,
          iconName: item.icon,
          url: item.url,
          description: item.description,
          disabled: item.disabled,
          productionReady: item.productionReady,
        };
      }),
  settingsMode: false,
};

const operationURLS = {
  list: "actionCodeMaster/list",
  update: "actionCodeMaster/update",
  create: "actionCodeMaster/create",
  delete: "actionCodeMaster/delete",
};


const getColumns = (onDelete, onEdit) => {
  return [
    {
      Header: "Code Type",
      accessor: "codetype",
      displayInList: true,
      allowFilter: true,
      allowInForm: true,
      dataType: "string",
      validation: formControl.string().required("Required"),
      Cell: ({ row, value }) => <DefaultCell row={row} value={value} />,
      controlType: "select",
      filterControlType: "select",
      options: {
        keyField: "value",
        keyDescription: "label",
        values: [
          { value: "code", label: "code" },
          { value: "ac", label: "ac" },
          { value: "vg", label: "vg" },
        ],
        url: "",
      },
    },
    {
      Header: "Short Code",
      accessor: "shortcode",
      displayInList: true,
      allowFilter: false,
      allowInForm: true,
      dataType: "string",
      validation: formControl.string().required("Required"),
      Cell: ({ row, value }) => <DefaultCell row={row} value={value} />,
    },
    {
      Header: "Description",
      accessor: "description",
      displayInList: true,
      allowFilter: false,
      allowInForm: true,
      dataType: "string",
      validation: formControl.string().required("Required"),
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Action",
      accessor: "id",
      displayInList: true,
      sortDisable: true,
      Cell: ({ row, value }) => (
        <RowAction
          row={row}
          value={value}
          onDelete={onDelete}
          onEdit={onEdit}
        />
      ),
    },
  ];
};

export { getColumns, Attributes, operationURLS };
